import { InjectionToken } from '@angular/core';
import { Segment, SegmentVariant } from '@cbre/components';
import { Elevator } from '@miq/domain/pv';

export interface ElevatorToSegmentAdapterService<T = any> {
  adapt(params: T): { [key: number]: Segment };
}

export const ElevatorToSegmentAdapterServiceToken = new InjectionToken<ElevatorToSegmentAdapterService>(
  `ElevatorToSegmentAdapterService`
);

export class PVElevatorToVerticalSegmentAdapter implements ElevatorToSegmentAdapterService<Elevator[]> {
  adapt(elevatorList: Elevator[]): { [key: number]: Segment } {
    return (elevatorList ?? []).reduce(
      (eleMap, ele) => ({ ...eleMap, [ele.index]: { variant: SegmentVariant.Primary } }),
      {}
    );
  }
}
